import { Environment } from '@lfg/core/enums';
import { bsc, bscTestnet } from 'viem/chains';
import { useAccount, useChainId, useConfig } from 'wagmi';

import { APP_ENV } from '@/global/configs/common.config';

export const useWeb3 = () => {
  const { address, chain } = useAccount();
  const config = useConfig();
  const chainId = useChainId();

  const getTargetChainId = () => {
    return APP_ENV !== Environment.PROD ? bscTestnet.id : bsc.id;
  };

  const targetChainId = getTargetChainId();
  const isWrongNetwork = chainId !== targetChainId;

  return {
    address,
    config,
    chainId,
    isWrongNetwork,
    chain,
    targetChainId,
  };
};
